import { Link } from "react-router-dom";
import "./HomeDashboard.css";
import React, { useEffect, useState } from "react";
function HomeDashboard() {
  const [user, setUser] = useState("");

  useEffect(() => {
    const encodedUserInfo = localStorage.getItem("UserInfo");

    if (encodedUserInfo) {
      try {
        // Decode the Base64 string
        const userInfo = atob(encodedUserInfo);
        // Parse the JSON string back into an object
        setUser(JSON.parse(userInfo));
      } catch (error) {
        console.error("Error decoding or parsing user info:", error);
      }
    }
  }, []); // Empty dependency array to run only once on mount

  return (
    <div className="home-container">
      <h1>Hello, {user?.UserName ?? "--"}</h1>
      <h2>Welcome to ContractAssist, how can I help you?</h2>

      <div className="grid">
        <Link to="/dashboard/legal-analyzer">
          <div className="card">
            <span className="icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="10" cy="10" r="6" />
                <line x1="14" y1="14" x2="21" y2="21" />

                <line x1="10" y1="4" x2="10" y2="2" />
                <line x1="6" y1="7" x2="10" y2="4" />
                <line x1="10" y1="4" x2="14" y2="7" />
                <line x1="6" y1="7" x2="6" y2="12" />
                <line x1="14" y1="7" x2="14" y2="12" />
                <circle cx="6" cy="12" r="1.5" />
                <circle cx="14" cy="12" r="1.5" />
              </svg>
            </span>
            <h4>Contract Assist</h4>
            <p>
            Contract Assist leverages advanced AI and machine learning to streamline the review process
            </p>
            <div className="shine"></div>
            <div className="background">
              <div className="tiles">
                <div className="tile tile-1"></div>
                <div className="tile tile-2"></div>
                <div className="tile tile-3"></div>
                <div className="tile tile-4"></div>

                <div className="tile tile-5"></div>
                <div className="tile tile-6"></div>
                <div className="tile tile-7"></div>
                <div className="tile tile-8"></div>

                <div className="tile tile-9"></div>
                <div className="tile tile-10"></div>
              </div>

              <div className="line line-1"></div>
              <div className="line line-2"></div>
              <div className="line line-3"></div>
            </div>
          </div>
        </Link>

        <Link to="/dashboard/legal-summary">
          <div className="card">
            <span className="icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M6 2h9l5 5v13c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2z" />
                <path d="M14 2v6h6" />

                <path d="M9 12h6" />
                <path d="M9 16h3" />

                <path d="M9 20l2 2 4-4" />
              </svg>
            </span>
            <h4>Contract Summary</h4>
            <p>
              Contract Summary offers a brief overview of key points in legal
              documents.
            </p>
            <div className="shine"></div>
            <div className="background">
              <div className="tiles">
                <div className="tile tile-1"></div>
                <div className="tile tile-2"></div>
                <div className="tile tile-3"></div>
                <div className="tile tile-4"></div>

                <div className="tile tile-5"></div>
                <div className="tile tile-6"></div>
                <div className="tile tile-7"></div>
                <div className="tile tile-8"></div>

                <div className="tile tile-9"></div>
                <div className="tile tile-10"></div>
              </div>

              <div className="line line-1"></div>
              <div className="line line-2"></div>
              <div className="line line-3"></div>
            </div>
          </div>
        </Link>
      </div>

      <label className="day-night">
        <input type="checkbox" defaultChecked />
        <div></div>
      </label>
    </div>
  );
}

export default HomeDashboard;
